import React, { Component } from 'react';
import { Table, Row, Col, InputNumber, Button, DatePicker, message, Spin, Input } from 'antd';
import moment from 'moment';
import { data7_3_default } from './data';
import imgSave from "../../saveImg";
import Auth from "../../Auth";
import './index.scss';

const { TextArea } = Input;
const { MonthPicker } = DatePicker;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            data7_3_1: [{
                'comments': ''
            }],
            loading: true,
            print: false,
            loadingSave: false,
            loadingNote: false
        }
    }


    componentDidMount() {
        this.getTable7_3(this.state.date);
        this.getTable7_3_1(this.state.date);
        // this.computeNum(this.state.data)
    }



    computeNum = (data) => {

        data[10].no_employee = data.reduce((a, b, i) => {
            if (i < 10) {
                a += Number(b.no_employee || "0");
            }
            return a
        }, 0).toFixed(0);
        this.setState({
            data
        });

    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        // this.setState({
        //     data
        // });
        this.computeNum(data);
    }

    getTable7_3 = (date) => {
        const dataBegin = JSON.stringify(data7_3_default);
        let data = JSON.parse(dataBegin);

        fetch(`/_7_3_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                data = x.data;
            }

            if (!data[0].id) {
                this.setState({
                    loading: false,
                    data,
                }, () => {
                    this.onSave();
                });
                return
            }

            this.setState({
                loading: false,
                data
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        })
    }

    getTable7_3_1 = (date) => {
        const dataBegin = JSON.stringify(data7_3_default);
        let data = JSON.parse(dataBegin);

        fetch(`/_7_3_1_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                data = x.data;
            }

            this.setState({
                loading: false,
                data7_3_1: data
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_7_3', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getTable7_3(this.state.date);
                    this.getTable7_3_1(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            console.error(err);
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000);
            message.error('保存失败' + JSON.stringify(err));
        })
    }
    onSave7_3_1 = () => {
        this.setState({ loadingNote: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            this.setState({ loadingNote: false });
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data7_3_1.map(x => ({ ...x, year }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_7_3_1', headres).then(x => x.json()).then(x => {
            this.setState({ loadingNote: false });
            if (x.status == 1) {
                message.success(x.msg);
                return
            }
            message.error(x.msg);
        }).catch(err => {
            this.setState({ loadingNote: false });
            console.error(err);
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table7_3', 1.5, '7.30', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const data = this.state.data;
        const columns = [{
            title: 'Title 职位名称',
            dataIndex: 'title',
            key: 'title',
            align: "center",
            // fixed: "left",
            // width: 100,
            render: (text, record, index) => {
                if (index == 10) {
                    return (
                        <div className="table-padding table-color-footer">
                            {text}
                        </div>
                    )
                }
                return (
                    <div className="table-color table-color-number">
                        <Input
                            className="input-width"
                            precision={0}
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = e.target.value;
                                this.onChange('title', value, index)
                            }}
                        // onChange={(value) => {
                        //     this.onChange('actual', value, index)
                        // }}
                        />
                    </div>
                )
            }
        }, {
            title: 'Level 职级',
            dataIndex: 'level',
            key: 'level',
            align: "center",
            // width: 100,
            render: (text, record, index) => {
                if (index == 10) {
                    return (
                        <div className="table-padding table-color-footer">
                            -
                        </div>
                    )
                }
                return (
                    <div className="table-color table-color-number">
                        <Input
                            className="input-width"
                            precision={0}
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = e.target.value;
                                this.onChange('level', value, index)
                            }}
                        // onChange={(value) => {
                        //     this.onChange('actual', value, index)
                        // }}
                        />
                    </div>
                )
            }
        }, {
            title: <div>Vacant Since  <br /> 自何时开始空缺</div>,
            dataIndex: 'vacant_since',
            key: 'vacant_since',
            align: "center",
            // width: 100,
            render: (text, record, index) => {
                if (index == 10) {
                    return (
                        <div className="table-padding table-color-footer">
                            -
                        </div>
                    )
                }
                return (
                    <div className="table-color table-color-number">
                        <Input
                            className="input-width"
                            precision={0}
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = e.target.value;
                                this.onChange('vacant_since', value, index)
                            }}
                        />
                    </div>
                )
            }
        }, {
            title: <div>No. of Employee   <br /> 招聘人数</div>,
            dataIndex: 'no_employee',
            key: 'no_employee',
            align: "center",
            // width: 100,
            render: (text, record, index) => {
                if (index == 10) {
                    return (
                        <div className="table-padding table-color-footer" style={{ textAlign: "right" }}>
                            {text}
                        </div>
                    )
                }
                return (
                    <div className="table-color table-color-number">
                        <InputNumber
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            precision={0}
                            className="table_numInput"
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                value = Number(value.toFixed(0));
                                this.onChange('no_employee', value, index)
                            }}

                        />
                    </div>
                )
            }
        }, {
            title: <div>Internal Development Plan <br /> 内部发展计划</div>,
            dataIndex: 'internal_develop_plan',
            key: 'internal_develop_plan',
            align: "center",
            // width: 100,
            render: (text, record, index) => {
                if (index == 10) {
                    return (
                        <div className="table-padding table-color-footer">
                            -
                        </div>
                    )
                }
                return (
                    <div className="table-color table-color-number">
                        <Input
                            className="input-width"
                            precision={0}
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = e.target.value;
                                this.onChange('internal_develop_plan', value, index)
                            }}
                        // onChange={(value) => {
                        //     this.onChange('actual', value, index)
                        // }}
                        />
                    </div>
                )
            }
        }, {
            title: <div>Recruit Channel  <br /> 招聘渠道</div>,
            dataIndex: 'recruit_channel',
            key: 'recruit_channel',
            align: "center",
            // width: 100,
            render: (text, record, index) => {
                if (index == 10) {
                    return (
                        <div className="table-padding table-color-footer">
                            -
                        </div>
                    )
                }
                return (
                    <div className="table-color table-color-number">
                        <Input
                            className="input-width"
                            precision={0}
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = e.target.value;
                                this.onChange('recruit_channel', value, index)
                            }}
                        // onChange={(value) => {
                        //     this.onChange('actual', value, index)
                        // }}
                        />
                    </div>
                )
            }
        }, {
            title: <div>Plans and Actions  <br /> 计划及行动方案</div>,
            dataIndex: 'plan_action',
            key: 'plan_action',
            align: "center",
            // width: 100,
            render: (text, record, index) => {
                if (index == 10) {
                    return (
                        <div className="table-padding table-color-footer">
                            -
                        </div>
                    )
                }
                return (
                    <div className="table-color table-color-number">
                        <Input
                            className="input-width"
                            precision={0}
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = e.target.value;
                                this.onChange('plan_action', value, index)
                            }}
                        // onChange={(value) => {
                        //     this.onChange('actual', value, index)
                        // }}
                        />
                    </div>
                )
            }
        }, {
            title: 'Remarks 备注',
            dataIndex: 'remarks',
            key: 'remarks',
            align: "center",
            // width: 100,
            render: (text, record, index) => {
                if (index == 10) {
                    return (
                        <div className="table-padding table-color-footer">
                            -
                        </div>
                    )
                }
                return (
                    <div className="table-color table-color-number">
                        <Input
                            className="input-width"
                            precision={0}
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = e.target.value;
                                this.onChange('remarks', value, index)
                            }}
                        // onChange={(value) => {
                        //     this.onChange('actual', value, index)
                        // }}
                        />
                    </div>
                )
            }
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1 table7_3" id="table7_3" >
                    <Row className="title">
                        <Row>7.3 Recruitment Plan (B2 and above, Vacant Positions) & Succession Plan 空缺职位招聘(B2级以上）及接班人计划</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: []
                                    });
                                    this.getTable7_3(this.state.date);
                                    this.getTable7_3_1(this.state.date);
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            pagination={false}
                            className="content"
                            rowKey={(record, index) => index}
                        />
                        <Row className="table-footer-btn" style={{ display: this.state.print ? 'none' : "" }}>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Row>
                    </Row>
                    <Row className="title">
                        <Row>7.3.1 Comments备注: </Row>
                        <TextArea
                            autosize={{ minRows: 4 }}
                            value={this.state.data7_3_1[0] ? this.state.data7_3_1[0]['comments'] : ''}
                            onChange={(e) => {
                                let data7_3_1 = this.state.data7_3_1;
                                data7_3_1[0]['comments'] = e.target.value;

                                this.setState({
                                    data7_3_1
                                })
                            }}

                        />
                        <Auth loading={this.state.loading} auth="edit_7_3">
                            <Row className="table-footer-btn" style={{ display: this.state.print ? 'none' : "" }}>
                                <Button
                                    type="primary"
                                    style={{ marginRight: 10 }}
                                    onClick={this.downloadSG}
                                    loading={this.state.print}
                                >加入pdf</Button>
                                <Button
                                    type="primary"
                                    onClick={this.onSave7_3_1}
                                    loading={this.state.loadingNote}
                                >保存</Button>
                            </Row>
                        </Auth>

                    </Row>
                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-3/7-3.js